"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserStorage = /** @class */ (function () {
    function BrowserStorage(cipher, jsCookies) {
        this.serializer = JSON;
        this.cipher = cipher;
        this.persistLevelSession = false;
        this.cookiesService = jsCookies;
    }
    BrowserStorage.prototype.getDriver = function () {
        return this.persistLevelSession ? sessionStorage : localStorage;
    };
    BrowserStorage.prototype.serialize = function (data) {
        return this.serializer.stringify(data);
    };
    BrowserStorage.prototype.unSerialize = function (serialized) {
        return this.serializer.parse(serialized);
    };
    BrowserStorage.prototype.set = function (key, data, ciphered) {
        var serialized = this.serialize(data);
        if (ciphered && this.cipher) {
            serialized = this.cipher.encrypt(serialized);
        }
        this.getDriver().setItem(key, serialized);
    };
    BrowserStorage.prototype.get = function (key, ciphered) {
        var data = this.getDriver().getItem(key);
        if (data === null) {
            return data;
        }
        if (ciphered && this.cipher) {
            data = this.cipher.decrypt(data);
        }
        return this.unSerialize(data);
    };
    BrowserStorage.prototype.remove = function (key) {
        this.getDriver().removeItem(key);
    };
    BrowserStorage.prototype.setPersistLevelSession = function (value) {
        this.persistLevelSession = value;
        return this;
    };
    BrowserStorage.prototype.removeAll = function () {
        this.getDriver().clear();
    };
    BrowserStorage.prototype.getCookie = function (key) {
        var _a;
        return (_a = this.cookiesService.get(key)) !== null && _a !== void 0 ? _a : null;
    };
    BrowserStorage.prototype.removeCookie = function (key) {
        this.cookiesService.remove(key);
    };
    BrowserStorage.prototype.setCookie = function (key, value, expires) {
        var attributes = {};
        if (expires) {
            attributes.expires = expires;
        }
        this.cookiesService.set(key, value, attributes);
    };
    return BrowserStorage;
}());
exports.default = BrowserStorage;
